import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = false;

const isReady = () => true;
const isAwaiting = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_APPOINTMENT_REQUEST]: isAwaiting,
  [actionTypes.APPLICATION_IS_READY]: isReady,
});
